module.exports = __webpack_public_path__ + "img/clockGrey.5fb0dd2a.svg";